import { ethers } from 'ethers';
import { USDC_DECIMALS, ZENOVA_DECIMALS } from '../config/contracts';

export const shortAddress = (addr, chars = 4) => {
  if (!addr) return '';
  return `${addr.slice(0, chars + 2)}...${addr.slice(-chars)}`;
};

export const formatUsdc = (bn, decimals = 2) => {
  if (!bn) return '0.00';
  try {
    const val = ethers.utils.formatUnits(bn, USDC_DECIMALS);
    return parseFloat(val).toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  } catch (e) {
    return '0.00';
  }
};

export const formatZenova = (bn, decimals = 4) => {
  if (!bn) return '0.00';
  try {
    const val = ethers.utils.formatUnits(bn, ZENOVA_DECIMALS);
    return parseFloat(val).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: decimals
    });
  } catch (e) {
    return '0.00';
  }
};

export const parseUsdc = (value) => {
  return ethers.utils.parseUnits(String(value), USDC_DECIMALS);
};

export const formatBps = (bps) => {
  if (!bps) return '0%';
  const n = typeof bps === 'object' ? bps.toNumber() : Number(bps);
  return `${(n / 100).toFixed(2)}%`;
};

export const formatTimestamp = (ts) => {
  if (!ts) return '-';
  const n = typeof ts === 'object' ? ts.toNumber() : Number(ts);
  if (n === 0) return '-';
  return new Date(n * 1000).toLocaleString();
};

export const formatRelative = (ts) => {
  if (!ts) return '-';
  const n = typeof ts === 'object' ? ts.toNumber() : Number(ts);
  const diff = Math.floor(Date.now() / 1000) - n;
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};

export const formatNumber = (n, decimals = 0) => {
  if (n == null) return '0';
  const val = typeof n === 'object' ? n.toString() : n;
  return parseFloat(val).toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
};

export const bnToNumber = (bn) => {
  if (!bn) return 0;
  if (typeof bn === 'object' && bn.toNumber) return bn.toNumber();
  return Number(bn);
};

export const isSameAddress = (a, b) => {
  if (!a || !b) return false;
  return a.toLowerCase() === b.toLowerCase();
};
